







































































import {
  defineComponent,
  PropType,
  defineVue3AsyncComponent
} from '~/utils/nuxt3-migration'
import CCarousel from '~/components/shared/configurable/image/carousel/CCarousel.vue'
import { photoEnlargementHash } from '~/models/view'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import {
  REMOVE_PROCESSED_PHOTO,
  SET_BIG_PHOTOS_VISIBLE
} from '~/store/modules/shared/classifieds/view/mutation-types'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { useModalToggle } from '~/compositions/modal-toggle'
import { ShortVideo } from '~/models/short-video'

export default defineComponent({
  components: {
    CCarousel,
    CCarouselBigImagesModal: defineVue3AsyncComponent(() =>
      import(
        '~/components/shared/configurable/image/carousel/CCarouselBigImagesModal.vue'
      )
    )
  },
  setup() {
    const modalToggleFunc = useModalToggle()
    return { modalToggleFunc }
  },
  props: {
    bigSize: { type: String, default: 'b' },
    mediumSize: { type: String, default: 'z' },
    thumbSize: { type: String, default: 'v' },
    type: {
      type: String,
      required: false,
      default: 'carousel'
    },
    classified: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    loadedThumbIndex: {
      type: Number,
      required: false,
      default: 0
    },
    price: { type: String, default: null },
    title: { type: String, default: '' },
    seller: { type: Object, default: null },
    showTelephone: {
      type: Boolean,
      default: true
    },
    showPrice: {
      type: Boolean,
      default: true
    },
    site: { type: String, default: 'car' },
    viewType: { type: String, default: null },
    placeholderImage: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: false,
      default: null
    },
    noThumbs: { type: Boolean, required: false, default: false },
    counterPosition: {
      type: String as PropType<'top' | 'bottom'>,
      required: false,
      default: 'bottom'
    },
    imageClass: {
      type: [String, Object],
      default: null
    },
    displayVideo: {
      type: Boolean,
      default: false
    },
    shortVideos: {
      type: Array as PropType<ShortVideo[]>,
      default: () => []
    }
  },
  data: () => ({
    loadBigPhotos: false,
    bpIndex: null,
    bpCurrent: null,
    showBigPhotos: false,
    showShortVideo: false
  }),
  computed: {
    ...mapGetters(USER_AGENT_NS, {
      isPc: 'isPc'
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      processedPhotos: 'processedPhotos',
      photos360: 'photos360',
      classifiedHasNativePhotos: 'classifiedHasNativePhotos',
      userIsOwner: 'isOwn'
    }),
    ...mapState(CLASSIFIED_VIEW_NS, {
      bigPhotosVisible: state => state.bigPhotosVisible
    }),
    youtubeId() {
      if (this.classified.videos.length) {
        return this.classified.videos[0].url
      }

      return ''
    },
    youtubeEmbedLink() {
      if (this.classified.videos.length) {
        return 'https://www.youtube.com/embed/' + this.classified.videos[0].url
      }

      return null
    },
    isPlotCategory() {
      return this.classified.category_ids.includes(20002)
    },
    classifiedPrice() {
      const price =
        this.classified.payment ||
        this.classified.salary ||
        this.classified.price
      if (price) {
        return price
      } else if (this.classified.finance?.price) {
        return { value: this.classified.finance.price }
      }
      return null
    },
    filteredProcessedPhotos() {
      if (this.displayVideo) {
        return this.processedPhotos
      }
      return this.processedPhotosWithoutVideo
    },
    processedPhotosWithoutVideo() {
      return this.processedPhotos.filter(i => i.type !== 'video')
    }
  },
  watch: {
    bigPhotosVisible(value) {
      if (value !== false) {
        // this should only trigger from other sources, not from gallery itself
        if (typeof value === 'string') {
          this.openBigPhotos(value)
        } else {
          this.openBigPhotos()
        }
      }
    }
  },
  mounted() {
    this.modalToggleFunc.setOnModalCloseCallback(this.onModalClose)
    this.modalToggleFunc.setHash(photoEnlargementHash)

    if (window.location.hash === '#' + photoEnlargementHash) {
      if (this.classifiedHasNativePhotos || this.shortVideos.length) {
        this.openBigPhotos()
      }
    }
  },
  methods: {
    ...mapMutations(CLASSIFIED_VIEW_NS, {
      setBigPhotosVisible: SET_BIG_PHOTOS_VISIBLE,
      removeProcessedPhoto: REMOVE_PROCESSED_PHOTO
    }),
    openBigPhotos(tab = null, imageIndex = 0, showShortVideo: boolean = false) {
      tab = tab || 'photos'
      if (!['photos', '360', 'video'].includes(tab)) {
        this.$logger.captureError(
          new TypeError(`Switching to non-existent "${tab}" tab`)
        )
      }
      this.showShortVideo = showShortVideo

      this.bpCurrent = tab
      this.bpIndex = parseInt(imageIndex)

      this.loadBigPhotos = true
      this.showBigPhotos = true

      this.modalToggleFunc.modalOpen().then(() => {
        const index = this.getImageIndex(imageIndex, showShortVideo)
        setTimeout(() => {
          if (this.$refs.bigimages?.thumbClicked && !showShortVideo) {
            this.$refs.bigimages.thumbClicked(index, null)
          } else if (this.$refs.bigimages?.thumbClicked && showShortVideo) {
            this.$refs.bigimages.scrollToVideoAndPlay(index)
          }
        }, 200)
      })
    },
    getImageIndex(index: number, isShortVideo: boolean = false) {
      if (this.processedPhotosWithoutVideo.length > 0 && !isShortVideo) {
        return index === 0 ? index + (this.shortVideos.length || 0) : index
      } else if (
        this.shortVideos.length > 0 &&
        isShortVideo &&
        this.processedPhotosWithoutVideo.length
      ) {
        return index - 1
      }
      return index
    },
    closeBigPhotos() {
      this.modalToggleFunc.modalClose(false)
    },
    onModalClose() {
      this.showBigPhotos = false
      this.$refs.bigimages && this.$refs.bigimages.resetYoutube()
      // TODO: this should not communicate with the store but ignoring for now
      this.setBigPhotosVisible(false)
      this.showShortVideo = true
    }
  }
})
